import { useEffect, useState } from "react";
import { BookOpenCheck, EyeOff, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../../../connect/api";
import { Empty, Header, Spinner, ago } from "../ui";

const DayCard = ({ d, open, onToggle }) => {
  const pct = d.staff ? Math.round((100 * d.readers.length) / d.staff) : 0;
  return (
    <li className="nxc-card p-3" data-testid={`engagement-day-${d.day}`}>
      <button onClick={onToggle} className="w-full text-left" data-testid={`engagement-toggle-${d.day}`}>
        <div className="flex items-center justify-between gap-2">
          <div>
            <div className="font-semibold text-slate-100">{d.day}</div>
            <div className="text-[11px] text-slate-400">{d.posts} posts published · {d.opens} opens</div>
          </div>
          <div className="text-right">
            <div className={`text-lg font-semibold ${d.readers.length ? "text-emerald-300" : "text-slate-500"}`} data-testid={`engagement-readers-${d.day}`}>{d.readers.length}<span className="text-slate-500 text-xs font-normal"> / {d.staff}</span></div>
            <div className="text-[11px] text-slate-500">{pct}% opened</div>
          </div>
        </div>
        <div className="h-1.5 rounded-full bg-white/5 mt-2 overflow-hidden"><div className="h-full bg-emerald-400/70 rounded-full transition-[width]" style={{ width: `${pct}%` }} /></div>
      </button>
      {open && (
        <div className="mt-3 space-y-2 text-xs nxc-fade-in">
          <div className="text-emerald-300 flex items-center gap-1.5"><BookOpenCheck size={12} /> Opened</div>
          {d.readers.length === 0 && <div className="text-slate-500 pl-4">Nobody yet</div>}
          {d.readers.map((r) => <div key={r.email} className="pl-4 flex justify-between gap-2"><span className="text-slate-200 truncate">{r.name} <span className="text-slate-500">· {r.department}</span></span><span className="text-slate-500 shrink-0">{r.opens}× · {ago(r.last_at)}</span></div>)}
          <div className="text-slate-400 flex items-center gap-1.5 pt-1"><EyeOff size={12} /> Not opened</div>
          {d.non_readers.length === 0 && <div className="text-slate-500 pl-4">Everyone opened it</div>}
          {d.non_readers.map((r) => <div key={r.email} className="pl-4 text-slate-400 truncate">{r.name} <span className="text-slate-600">· {r.department}</span></div>)}
        </div>
      )}
    </li>
  );
};

export const AdminEngagement = () => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/engagement", { params: { days: 7 } }).then((r) => { setD(r.data); setOpen(r.data.days[0]?.day); }); }, []);
  const sendNow = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/engagement/send"); toast.success(data.ok ? "Report sent to your Telegram" : "Telegram not configured — report not sent"); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  const t = d?.report_time || [18, 30];
  return (
    <div className="h-full flex flex-col">
      <Header title="All Staff read report" sub={`Daily Telegram at ${String(t[0]).padStart(2, "0")}:${String(t[1]).padStart(2, "0")} IST · Mon–Sat`} back="/connect/admin"
        right={<button onClick={sendNow} disabled={busy} className="nxc-btn nxc-btn-ghost h-9 text-xs" data-testid="engagement-send-now">{busy ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />} Send now</button>} />
      <div className="flex-1 overflow-y-auto px-3 py-3 space-y-2" data-testid="admin-engagement">
        {!d ? <div className="flex justify-center py-10"><Spinner /></div> : d.days.length === 0 ? <Empty icon={BookOpenCheck} title="No data yet" /> : (
          <>
            <p className="text-[11px] text-slate-500 px-1">Counts staff (excluding you) who opened the All Staff India tab or a post that day. DM profiles are never counted.</p>
            <ul className="space-y-2">{d.days.map((x) => <DayCard key={x.day} d={x} open={open === x.day} onToggle={() => setOpen(open === x.day ? null : x.day)} />)}</ul>
          </>
        )}
      </div>
    </div>
  );
};
